import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';

@Component({ standalone: false, selector: 'app-form-reactive-switch',
  templateUrl: './reactive-switch.component.html',
})
export class FormReactiveSwitch<T> {
  @Input() label: string = '';
  @Input() title: string;
  @Input() inputFormControl: GlobalFormGroup<T> = null;
  @Input() inputClass: string = '';
  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;
  onChange(value: boolean) {
    this.asFormControl(this.inputFormControl).setValue(value);
  }
}
